<template>
  <funding-base :state="state" :current-funding-pot-id="fundingPot.id">
    <div class="container pt-12">
      <div class="bg-white shadow-lg">
        <article
          class="px-6 py-4 flex flex-col bg-white border-grey-300 relative border-b-0"
        >
          <div class="flex items-center mb-6">
            <div class="mr-6">
              <h2 class="text-xl leading-tight truncate mb-1">
                {{ request.name | sentencecase }}
              </h2>
              <p>{{ request.application_data.company_name }} | {{ request.application_data.company_role }}</p>
            </div>
            <div class="ml-auto">
              <a
                :href="route('funding.assessor-requests.download', [fundingPot.id, request.id])"
                class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-primary-300 text-primary-800 shadow text-sm font-semibold bg-primary-50 hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none ml-2"
                download
              >
                Download CV
              </a>
            </div>
          </div>
          <dl class="border-t-2 pt-6">
            <div
              v-for="(value, key) in lookup"
              :key="key"
              class="mb-2"
            >
              <dt class="font-bold mr-1">{{ value }}</dt>
              <dd v-html="parseMarkdown(autop(request[key] || request.application_data[key] || '--'), false)" />
            </div>
          </dl>
        </article>
      </div>
    </div>
    <div class="container mt-8">
      <ul class="list-reset flex justify-between items-baseline">
        <li class="w-1/3">
          <icon-link
            v-if="pagination.previous"
            :href="route('funding.assessor-requests.show', [fundingPot.id, pagination.previous])"
            icon="arrow-thin-left-circle"
          >
            Previous: {{ pagination.previous.name | sentencecase }}
          </icon-link>
        </li>
        <li class="w-1/3 text-center">
          <icon-link
            :href="route('funding.assessor-requests.index', [fundingPot.id])"
            class="text-primary-600 hover:text-primary-800"
          >
            Back to List
          </icon-link>
        </li>
        <li class="w-1/3 text-right">
          <icon-link
            v-if="pagination.next"
            :href="route('funding.assessor-requests.show', [fundingPot.id, pagination.next])"
            icon="arrow-thin-right-circle"
            icon-placement="right"
          >
            Next: {{ pagination.next.name | sentencecase }}
          </icon-link>
        </li>
      </ul>
    </div>
  </funding-base>
</template>

<script>

export default {
    name: 'FundingAssessorRequestsIndex',
    computed: {
      lookup() {
        return this.state.lookup;
      },
      fundingPot() {
        return this.state.funding_pot;
      },
      request() {
        return this.state.request;
      },
      pagination() {
        return this.state.pagination;
      },
    },
}
</script>
